import React, { useState } from 'react'
import {Col, Row} from "reactstrap";
import { connect } from "react-redux";

// actions
import { ButtonNew } from "../../../components/buttons/buttonsActions";

const PropuestaSlide = props => {
    const { Form, List } = props
    const [itemToEdit, setItemToEdit] = useState({});
    const [showItem, setShowItem] = useState(false);

    const createItem = () => {
        setShowItem(true)
    }

    return <>
        <Row>
            {
                !showItem && <Col md="12">
                    <div className="d-flex align-items-center">
                        <div className="ml-auto paddingAdd">
                            <ButtonNew onClick={createItem} />
                        </div>
                    </div>
                </Col>
            }
            <Col>
                {
                    showItem ?
                        <Form
                            parent={props.data}
                            itemToEdit={itemToEdit}
                            setShowItem={setShowItem}
                            setItemToEdit={setItemToEdit}
                        /> :
                        <List setShowItem={setShowItem} setItemToEdit={setItemToEdit} />
                }
            </Col>
        </Row>
    </>
}


const mapStateToProps = state => ({
    mainProps : state.mainProps
});

const mapActionsToProps = ({});

export default connect(mapStateToProps, mapActionsToProps)(PropuestaSlide)